import { render, staticRenderFns } from "./LockableCard.vue?vue&type=template&id=dd07a064&scoped=true"
import script from "./LockableCard.vue?vue&type=script&lang=js"
export * from "./LockableCard.vue?vue&type=script&lang=js"
import style0 from "./LockableCard.vue?vue&type=style&index=0&id=dd07a064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../.pnpm-store/v11/links/@/vue-loader/15.11.1/6eff93d7107be10a36f1ed991dd8c448aca9b1ca7fe7bab80a7f2c3e35a8f285/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd07a064",
  null
  
)

export default component.exports